import React, { useContext, useEffect, useRef } from 'react'
import { useClickAway, useKeyPress } from 'react-use'
import styled from 'styled-components'
import { Button, colors } from '@giphy/react-giphy-brand'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { Modal } from '../modal'
import download from 'downloadjs'
import DashboardUserContext from '../../../site/dashboard/context'
import { request } from '../../api'

const Container = styled.div`
    position: absolute;
    top: 170px;
    left: 50%;
    width: 620px;
    height: auto;
    padding: 55px;
    transform: translateX(-50%);
    background-color: ${colors.giphyDarkestGrey};
    & p {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        margin: 0;
        line-height: 25px;
    }
`

const Links = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 35px;
`

const DownloadButton = styled(Button)`
    height: 44px;
    width: 248px;
    color: ${colors.giphyWhite};
    background-color: ${colors.giphyDarkGrey};
    &:hover {
        color: ${colors.giphyBlue};
    }
    i {
        margin-right: 5px;
        top: 3px;
        position: relative;
    }
`

type Props = {
    csv: string
    csvCtr: string
    onClose: () => void
}

const CsvModal = ({ csv, csvCtr, onClose }: Props) => {
    const [isEscPressed] = useKeyPress((event: KeyboardEvent) => event.keyCode === 27)
    const { user } = useContext(DashboardUserContext)

    useEffect(() => {
        if (isEscPressed) {
            onClose()
        }
    }, [isEscPressed])
    const ref = useRef(null)
    useClickAway(ref, () => {
        onClose()
    })

    const downloadCSV = async csvUrl => {
        const response = await request(
            csvUrl,
            {
                headers: {},
                credentials: 'omit',
            },
            user.token,
            false
        )
        const fileName = response.headers.get('content-disposition').split('"')[1]
        download(await response.blob(), fileName, 'text/csv')

        googleAnalyticsEvent({
            category: 'Dashboard',
            action: 'CSV Download',
            label: 'Views',
        })
    }

    return (
        <Modal>
            <Container ref={ref}>
                <p>{`Select the data you'd like to download for your GIFs. Engagement Rate on GIPHY shows the percentage of times a user engages with your GIFs in search!`}</p>
                <Links>
                    <div>
                        <DownloadButton onClick={() => downloadCSV(csv)}>
                            <i className={'ss-download'} />
                            <span>View Count CSV</span>
                        </DownloadButton>
                    </div>
                    <a href={csvCtr}>
                        <DownloadButton
                            onClick={() =>
                                googleAnalyticsEvent({
                                    category: 'Dashboard',
                                    action: 'CSV Download',
                                    label: 'Engagement Rate',
                                })
                            }
                        >
                            <i className={'ss-download'} />
                            <span>Engagement Rate CSV</span>
                        </DownloadButton>
                    </a>
                </Links>
            </Container>
        </Modal>
    )
}

export default CsvModal
